import Vue from 'vue'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import router from './router/router.js'
import store from './store'
import './axios';
import VueNotification from '@kugatsu/vuenotification'
import moment from 'moment'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import ValidationError from '@/directives/ValidationError';
import ACCESS_CONTROL from './utils/access-control';
import CONFIG from '@/assets/js/config.js';

Vue.directive('error', ValidationError);

Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(VueNotification, {
  success: {
    background: "green",
    color: "white"
  }
});

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY');
  }
});

Vue.filter('numFormat', function (value) {
  if (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return value;
  }
});

Vue.filter('numDeciFormat', function (value) {
   const n = Number(value);
   if (!Number.isFinite(n)) return '0.00';
  return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

Vue.filter("nameFormat", function(value) {
  return value.length > 16 ? value.replace(/(<([^>]+)>)/gi, " ").substring(0, 16) + `...`: value;
});

Vue.filter("adminDisplayName", function (value) {
  if (value) {
    return value.length > 16 ? value.replace(/(<([^>]+)>)/gi, " ").substring(0, 16) + `...` : value;
  } else {
    return value;
  }
});

Vue.prototype.formatDateRange = function(joinDate, deletedAt) {
  if (joinDate) {
    const joinDateFormatted = moment(String(joinDate)).format('YYYY');
    const deletedAtFormatted = deletedAt ? moment(String(deletedAt)).format('YYYY') : 'Now';
    return joinDateFormatted + ' ~ ' + deletedAtFormatted;
  }
};

Vue.prototype.truncateText = function(text, charLimit) {
  if (text === null || text === undefined) text = '';
  if (typeof text !== 'string' || text.trim() === '') return "-";

  const cleanText = text.replace(/(<([^>]+)>)/gi, " ").trim();
  return cleanText.length > charLimit
            ? cleanText.substring(0, charLimit) + "..."
            : cleanText;
};

Vue.mixin({
  methods: {
    // Customize
    auth(guard) {
      const user = this.$store.state.user;
      const isAuth = (user.teacher_no ? 'teacher' : 'admin') === guard;

      return {
        user: () => (isAuth || guard === null) ? this.$store.state.user : null,
        check: () => isAuth
      }
    },
    can(module, action) {
      const user = this.$store.state.user;
      if (!user) return false;

      const permissions = ACCESS_CONTROL[module]?.[action] ?? [];

      if (this.auth('admin').check()) {
        const roleId = Number(user.role);
        return (user.admin_no === "0001" || roleId === CONFIG.ROLE.ID.SUPER_ADMIN || permissions.includes(roleId));
      }

      if (this.auth('teacher').check()) {
        return this.getTeacherRole(module, action);
      }

      return false;
    },
    getTeacherRole(module, action) {
      const user = this.auth('teacher').user();
      const moduleAction = ACCESS_CONTROL[module]?.[action] ?? [];

      return user?.roleLabels.some(label => moduleAction.includes(label));
    }
  }
});

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
// Customize

